import IRService from "../../../api/IRService";
import { ActionTypes as action } from "./action-types";

const actions = {
  async getStocks({ commit }) {
    const res = await IRService.getStocks();
    commit(action.GET_STOCKS_DATA, res.data);
    return res.data;
  },
  resetState({ commit }) {
    commit(action.RESET_STATE);
  },
};

export default actions;
